import { render, staticRenderFns } from "./InvitedUsersTable.vue?vue&type=template&id=b64b4cd4&"
import script from "./InvitedUsersTable.vue?vue&type=script&lang=js&"
export * from "./InvitedUsersTable.vue?vue&type=script&lang=js&"
import style0 from "./InvitedUsersTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports